import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { nacodaraSection, learningCard, languageSection, languages } from '../mockData';
import { ArrowRight } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const NacodaraSection = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      toast({
        title: "Inscrito!",
        description: `Obrigado por se inscrever! ${email}`,
      });
      setEmail('');
    }
  };

  const handleLearnMore = () => {
    navigate('/about');
  };

  return (
    <div className="nacodara-section">
      <div className="container">
        <div className="nacodara-grid">
          {/* Left Side */}
          <div className="nacodara-left">
            <div className="brand-logo-large">
              <img className='h-20 w-auto' src="/logo.png" alt="nacodaralogo" />
            </div>
            <h2 className="section-heading">{nacodaraSection.heading}</h2>
            <p className="section-description">{nacodaraSection.stats}</p>
            <Button onClick={handleLearnMore} className="learn-more-btn">{nacodaraSection.ctaButton}</Button>
          </div>

          {/* Right Side - Card */}
          <div className="nacodara-right">
            <div className="learning-card">
              <div className="card-content">
                <div className="card-left">
                  <h3 className="card-title">
                    {learningCard.title}<br />
                    <span className="card-title-accent">{learningCard.subtitle}</span>
                  </h3>
                  <p className="card-description">{learningCard.description}</p>
                  
                  <div className="subscription-form">
                    <p className="form-heading">{learningCard.formHeading}</p>
                    <form onSubmit={handleSubscribe} className="email-form">
                      <Input
                        type="email"
                        placeholder={learningCard.emailPlaceholder}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="email-input"
                      />
                      <Button type="submit" className="subscribe-btn">
                        {learningCard.subscribeButton}
                      </Button>
                    </form>
                  </div>
                </div>
                <div className="card-right">
                  <img
                    src="https://images.unsplash.com/photo-1653564142033-ab3532091515?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxwcm9ncmFtbWluZyUyMGxlYXJuaW5nfGVufDB8fHx8MTc2MjcwOTc1M3ww&ixlib=rb-4.1.0&q=85"
                    alt="Learning illustration"
                    className="card-illustration"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Language Selection Section */}
        <div className="language-section">
          <div className="language-header">
            <h3 className="language-heading">{languageSection.heading}</h3>
            <p className="language-subheading">{languageSection.subheading}</p>
          </div>
          <div className="language-cards">
            {languages.map((lang) => (
              <div key={lang.id} className="language-card">
                <div className="language-icon" style={{ backgroundColor: `${lang.color}15` }}>
                  <span style={{ color: lang.color }}>{lang.icon}</span>
                </div>
                <h4 className="language-name">{lang.name}</h4>
                <p className="language-subtitle">{lang.subtitle}</p>
                <button className="language-view-btn">
                  View <ArrowRight size={16} />
                </button>
              </div>
            ))}
            <button className="view-all-btn">
              Veja todos os cursos <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NacodaraSection;
